import { Icons } from '@eppendorf/vnls-css/dist';
import { Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import cn from 'classnames';

import styles from './tab.module.scss';
import type { TabNavigationRoute } from './tabs.types';

export interface TabProps {
  route: TabNavigationRoute;
  isSelected: boolean;
  onClick: () => void;
}

export function Tab({ route, isSelected, onClick }: TabProps) {
  return (
    <button
      type="button"
      role="tab"
      aria-selected={isSelected}
      aria-controls={`tabpanel-${route.path}`}
      id={`tab-${route.path}`}
      className={cn(styles.tab, {
        [styles.tabSelected]: isSelected,
      })}
      onClick={onClick}
    >
      {route.icon && (
        <Icon
          size={IconSizeClasses.Small}
          name={route.icon as Icons}
          className={styles.icon}
        />
      )}
      <span className={styles.tabLabel}>{route.label}</span>
      {route.labelShort && (
        <span className={styles.tabLabelShort}>{route.labelShort}</span>
      )}
    </button>
  );
}
